<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/sjwh">盛京文化</router-link> >
      <router-link to="/sjwh/gushi">盛京医院的故事</router-link>
    </div>

    <div class="mt50 tv">
      <div class="container-width">
        <div class="tv-title">《盛京医院的故事》</div>
        <div class="tv-content">
          <div class="t-left">
            <!--   width: 490px; /* 490*1.65 */   height: 453px; /* 275*1.65 */ -->

            <video
              controls="controls"
              width="808"
              height="453"
              id="videoElement"
              style="border: 1px solid #999999"
              :poster="current.img"
            ></video>
            <!-- <div class="introduce_content">
              <div class="i-item">
                <span>全国首部由医疗机构独立策划的电视系列剧</span>
              </div>
              <div class="i-item">
                <span>全国首部由医疗机构独资制作的卫生行业剧</span>
              </div>
              <div class="i-item">
                <span>
                  全国首部以医疗单位真实人物和真实事件为创作原型的电视剧
                </span>
              </div>
              <div class="i-item">
                <span>全国首部由医疗机构工作人员出任全部演员的电视剧</span>
              </div>
            </div> -->
            <!-- <div class="title">当前播放的是：{{ current.title }}</div> -->
            <div class="download">
              <a :href="current.url" target="_blank">【点击下载】</a>
            </div>
            <div
              class=""
              style="width: 100%; margin-top: 20px; text-indent: 2.2rem"
            >
              由医院策划拍摄的 20集电视系列剧《盛京医院的故事》于2007
              年11月正式开机，并于次年3月完成拍摄。此剧是全国首部由医疗机构独立策划的电视系列剧，是全国首部由医疗机构独资制作的卫生行业剧，是全国首部以医疗单位真实人物和真实事件为创作原型的电视剧，是全国首部由医疗机构工作人员出任全部演员的电视剧。剧情以医院临床工作中实际发生的故事为原形，真实反映医护人员的辛苦与快乐，全部演员由医院职工担任，为医疗机构树立多元化品牌形象及精神文化导向提供了可以借鉴的经验与做法。
            </div>
          </div>
          <div class="t-right">
            <ul class="v-list">
              <li
                @click="changeTv(item)"
                v-for="(item, index) in list"
                :key="index"
                :class="current.id == item.id ? 'active' : ''"
              >
                <div class="">
                  <span class="t-name">{{ item.title }}</span>
                  <span class="t-time">【{{ item.releaseDate }}】</span>
                </div>
                <i
                  class="iconfont icon-bofang"
                  v-if="current.id == item.id"
                ></i>
              </li>
            </ul>
            <div class="pagination">
              <el-pagination
                :pager-count="5"
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template><script>
import service from "../../service/sjwh";
import config from "../../config/dev";
import BANNER from "../../components/banner/sjwh";
import flvjs from "flv.js";
export default {
  name: "HISTORY",
  data() {
    return {
      navigationData: [
        {
          name: "百年历史",
          path: "/sjwh",
          width: "50%",
        },
        {
          name: "院标/办院理念/院训/院歌",
          path: "/sjwh/yuange",
          width: "50%",
        },
        // {
        //   name: "盛京医讯",
        //   path: "/sjwh/zhoukan",
        //   width: "33%",
        // },
        // {
        //   name: "盛京TV",
        //   path: "/sjwh/tv",
        // },
        {
          name: "盛京映像",
          path: "/sjwh/yingxiang",
        },
        // {
        //   name: "盛京医院的故事",
        //   path: "/sjwh/gushi",
        // },
      ],
      currentPath: "/sjwh/gushi",
      pageIndex: 1,
      pageSize: 7,
      totalPages: 1,
      list: [],
      total: 0,
      config: config,
      flvPlayer: null,
      current: {
        title: "",
        video: "", // 视频地址
        url: "", // 下载地址
      },
    };
  },
  components: { BANNER },
  computed: {},
  created() {},
  beforeMount() {},
  methods: {
    play() {
      this.flvPlayer.play();
    },
    videoInit() {
      if (this.flvPlayer) {
        this.flvPlayer.pause();
        this.flvPlayer.unload();
        this.flvPlayer.detachMediaElement();
        this.flvPlayer.destroy();
        this.flvPlayer = null;
      }
      let _this = this;
      if (flvjs.isSupported()) {
        var videoElement = document.getElementById("videoElement");
        this.flvPlayer = flvjs.createPlayer(
          {
            type: "flv",
            isLive: true,
            hasAudio: true, // 是否有音频
            hasVideo: true, // 是否有视频
            url: _this.current.video,
            enableStashBuffer: false, //是否启用缓存区
          },
          {
            enableWorker: false, //不启用分离线程
            enableStashBuffer: false, //关闭IO隐藏缓冲区
            autoCleanupSourceBuffer: true, //自动清除缓存
            lazyLoad: false,
          }
        );
        this.flvPlayer.attachMediaElement(videoElement);
        this.flvPlayer.load();
        this.play();
      }
    },

    init() {
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
      };
      service.getSjStoryList(parmes, (res) => {
        this.total = res.totalElements || 0;
        this.totalPages = parseInt(res.totalPages) || 0;
        if (res.content.length) {
          // config.url + "/file/getVideo?id=" + item.video
          // config.url + "/file/downloadFile/" + item.video + "?isDownload=true";
          res.content.map((item) => {
            // 处理下载地址 和 视频地址
            if (item.url) {
              item.video = item.url;
            } else {
              // 下载地址
              item.url =
                config.url +
                "/file/downloadFile/" +
                item.video +
                "?isDownload=true";
              // 视频地址
              item.video = config.url + "/file/getVideo?id=" + item.video;
            }
            item.releaseDate = item.releaseDate
              ? item.releaseDate.substr(0, 10)
              : "";
            item.img =
              config.url +
              "/file/downloadFile/" +
              item.img +
              "?isDownload=true";
          });
        }
        this.current = { ...res.content[0] };
        this.list = res.content || [];
        this.videoInit();
      });
    },
    changeTv(item) {
      this.current = { ...item };
      this.videoInit();
    },

    handleCurrentChange(indexPage) {
      this.pageIndex = indexPage;
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
  destroyed() {
    if (this.flvPlayer) {
      this.flvPlayer.pause();
      this.flvPlayer.unload();
      this.flvPlayer.detachMediaElement();
      this.flvPlayer.destroy();
      this.flvPlayer = null;
    }
  },
};
</script>

<style scoped lang="scss">
.introduce_content {
  flex-wrap: wrap;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 808px;

  .i-item {
    margin-top: 20px;
    width: 49%;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;

    background: #00479d;
    border-radius: 50px;
    padding: 12px 0px;
    span {
      font-size: 13px;

      color: #fff;
    }
  }
}
.tv {
  background: #e6effc;
  .container-width {
    padding: 50px 0px;
    box-sizing: border-box;
    margin-bottom: 50px;
    .tv-title {
      display: block;
      width: 100%;
      text-align: center;
      font-size: 32px;
      margin-bottom: 30px;
    }
    .tv-content {
      display: -webkit-flex;
      display: flex;
      .t-left {
        background: #fff;
        padding: 30px 20px;
        box-sizing: border-box;
        border-radius: 5px;
        flex: 2.5;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title {
          margin: 20px auto 0;
          text-align: center;
          font-size: 24px;
        }
        .download {
          text-align: center;
          margin-top: 10px;
          a {
            font-size: 16px;
          }
        }
      }
      .t-right {
        flex: 1;
        background: #fff;
        padding: 30px 20px;
        box-sizing: border-box;
        margin-left: 30px;
        border-radius: 5px;
        position: relative;
        .v-list {
          display: -webkit-flex;
          display: flex;
          flex-wrap: wrap;
          li {
            width: 100%;
            padding: 10px 10px;
            margin: 0 0px 10px;
            box-shadow: 0 4px 7px rgba (0, 0, 0, 0.14);
            overflow: hidden;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            transition: 0.5s;
            background-color: #e7effc;
            display: -webkit-flex;
            display: flex;
            -webkit-box-pack: justify;
            -webkit-justify-content: space-between;
            -ms-flex-pack: justify;
            justify-content: space-between;
            -webkit-box-align: center;
            align-items: center;
            cursor: pointer;
            .t-name {
              font-size: 16px;
              height: 20px;
              display: block;
            }
            .t-time {
              font-size: 12px;
              color: #999;
              display: block;
              margin-top: 10px;
            }
            i {
              font-size: 30px;
            }
          }
          li:hover {
            background: #00479d;
            color: #fff;
            .t-time {
              color: #fff;
            }
          }
          .active {
            background: #00479d;
            color: #fff;
            .t-time {
              color: #fff;
            }
          }
        }
        .pagination {
          width: 410px;
          margin-top: 20px;
          margin-bottom: 0px;
          display: -webkit-flex;
          display: flex;
          -webkit-justify-content: center;
          justify-content: center;

          position: absolute;
          bottom: 20px;
          text-align: center;
        }
      }
    }
  }
  /deep/ .el-pager {
    li {
      padding: 0 15px !important;
    }
  }
}
@media only screen and (max-width: 420px) {
  .tv {
    .container-width {
      padding: 30px 0px;
      margin-bottom: 30px;

      .tv-content {
        display: -webkit-flex;
        display: flex;
        -webkit-box-orient: vertical; /* android 2.1-3.0, ios 3.2-4.3 */
        -webkit-flex-direction: column; /* Chrome 21+ */
        -ms-flex-direction: column; /* WP IE 10 */
        flex-direction: column; /* android 4.4 */
        .t-left {
          background: #fff;
          padding: 15px 10px;
          box-sizing: border-box;
          border-radius: 5px;
          .title {
            margin: 20px auto 0;
            text-align: center;
            font-size: 1.2rem;
          }
          video {
            width: 100%;
            height: auto;
          }
          .download {
            text-align: center;
            margin-top: 10px;
            a {
              font-size: 16px;
            }
          }
        }
        .t-right {
          padding: 15px 10px;
          margin-left: 0px;
          width: 100%;
          min-height: 200px;
          margin-top: 15px;
          .v-list {
            display: -webkit-flex;
            display: flex;
            flex-wrap: wrap;
            li {
              width: 100%;
              padding: 10px 10px;
              margin: 0 0px 10px;
              box-shadow: 0 4px 7px rgba (0, 0, 0, 0.14);
              overflow: hidden;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;
              transition: 0.5s;
              background-color: #e7effc;
              display: -webkit-flex;
              display: flex;
              -webkit-box-pack: justify;
              -webkit-justify-content: space-between;
              -ms-flex-pack: justify;
              justify-content: space-between;
              -webkit-box-align: center;
              align-items: center;
              cursor: pointer;
              .t-name {
                font-size: 16px;
                height: 20px;
                display: block;
              }
              .t-time {
                font-size: 12px;
                color: #999;
                display: block;
                margin-top: 10px;
              }
              i {
                font-size: 30px;
              }
            }
            li:hover {
              background: #00479d;
              color: #fff;
              .t-time {
                color: #fff;
              }
            }
            .active {
              background: #00479d;
              color: #fff;
              .t-time {
                color: #fff;
              }
            }
          }
          .pagination {
            width: 100%;
            position: initial;
          }
        }
      }
    }
  }
}
</style>
